import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const NotificationsTableRow = styled.div`
  display: flex;
  padding: ${Spacing.S16} ${Spacing.S24};
  border-bottom: 1px solid ${Color.Grey150};
`
